import { render, staticRenderFns } from "./DeliverableCard.vue?vue&type=template&id=04f5484e"
import script from "./DeliverableCard.vue?vue&type=script&lang=js"
export * from "./DeliverableCard.vue?vue&type=script&lang=js"
import style0 from "./DeliverableCard.vue?vue&type=style&index=0&id=04f5484e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports